import { useFormContext } from 'react-hook-form';

import jamieIcon from '@lib/core/src/assets/jamie-body.png';
import gmailIcon from '@lib/core/src/assets/third-party-logos/gmail.png';
import slackIcon from '@lib/core/src/assets/third-party-logos/slack.png';
import palette from '@lib/core/src/theme/palette';
import { styled } from '@mui/material';
import { RiChatAiLine } from '@remixicon/react';

import { Card } from '@/components/AiWorkflow/AiWorkflowStyles';

import NotifyBox from './NotifyBox';

const Container = styled(Card)({
  gap: 32
});

const Header = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 16
});

const IconBox = styled('div')({
  width: 44,
  height: 44,
  borderRadius: 24,
  background: palette.purple[200],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});

const Title = styled('div')({
  fontFamily: 'Reddit Sans',
  fontWeight: 500,
  fontSize: 16,
  color: palette.black,
  lineHeight: '21px'
});

const Description = styled('div')({
  fontFamily: 'Reddit Sans',
  fontWeight: 500,
  fontSize: 13,
  color: palette.grey[500],
  lineHeight: '16px',
  marginTop: 2
});

const Row = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
  gap: 19
});

const NOTIFICATION_OPTIONS = [
  {
    value: 'jamie',
    icon: <img src={jamieIcon} alt="Jamie" />,
    text: 'Jamie (Chat)',
    available: true,
    clickable: false
  },
  {
    value: 'email',
    icon: <img src={gmailIcon} alt="Gmail" />,
    text: 'Email',
    available: true,
    clickable: true
  },
  {
    value: 'slack',
    icon: <img src={slackIcon} alt="Slack" />,
    text: 'Slack',
    available: false,
    clickable: false
  }
];

const Notifications = () => {
  const { watch, setValue } = useFormContext();
  const notifications = watch('notifications') || null;

  const handleToggle = (
    e: React.MouseEvent,
    value: string,
    available: boolean,
    clickable: boolean
  ) => {
    e.stopPropagation();
    if (!available || !clickable) return;
    if (notifications[value] === true) {
      setValue('notifications', { ...notifications, [value]: false });
    } else {
      setValue('notifications', { ...notifications, [value]: true });
    }
  };

  return (
    <Container>
      <Header>
        <IconBox>
          <RiChatAiLine size={20} color={palette.purple[300]} />
        </IconBox>
        <div>
          <Title>Notify me</Title>
          <Description>Where should this agent send notifications?</Description>
        </div>
      </Header>
      <Row>
        {NOTIFICATION_OPTIONS.map(option => (
          <NotifyBox
            onClick={e => handleToggle(e, option.value, option.available, option.clickable)}
            key={option.value}
            icon={option.icon}
            text={option.text}
            isAvailable={option.available}
            isClickable={option.clickable}
            isSelected={notifications[option.value]}
          />
        ))}
      </Row>
    </Container>
  );
};

export default Notifications;
